export default function Input({ className = '', ...props }) {
  return (
    <input
      className={['input-base focus-ring', className].join(' ')}
      {...props}
    />
  );
}

export function Select({ className = '', children, ...props }) {
  return (
    <select
      className={['input-base focus-ring', className].join(' ')}
      {...props}
    >
      {children}
    </select>
  );
}

export function RadioGroup({ legend, options = [], name, value, onChange, className = '' }) {
  return (
    <fieldset className={className}>
      {legend && (
        <legend className="text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-2">
          {legend}
        </legend>
      )}
      <div className="space-y-2">
        {options.map((opt) => (
          <label key={opt.value} className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name={name}
              value={opt.value}
              checked={value === opt.value}
              onChange={onChange}
              className="text-primary-600 focus:ring-primary-500 border-neutral-300 dark:border-neutral-600"
            />
            <span className="text-sm text-neutral-700 dark:text-neutral-300">{opt.label}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}

export function Checkbox({ label, className = '', ...props }) {
  return (
    <label className={['flex items-center gap-2 cursor-pointer', className].join(' ')}>
      <input
        type="checkbox"
        className="rounded-clay-sm text-primary-600 focus:ring-primary-500 border-neutral-300 dark:border-neutral-600"
        {...props}
      />
      {label && (
        <span className="text-sm text-neutral-700 dark:text-neutral-300">{label}</span>
      )}
    </label>
  );
}
